import { TRANSFORM_ITEMS } from '../../../constants/homeData';
import Reveal from '../../common/Reveal';

function TransformSection() {
  return (
    <section className="px-4 py-12 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto max-w-2xl text-center">
          <Reveal variant="up">
            <h2 className="text-3xl font-bold text-[#1B1B1B] sm:text-4xl lg:text-[42px] xl:text-[48px]">
              Transform Your Career
            </h2>
          </Reveal>
          <Reveal variant="up" delay={90}>
            <p className="mt-3 text-base font-medium text-[#666666] sm:text-lg lg:text-[20px]">
              Learn smarter, build skills, and move confidently toward your goals.
            </p>
          </Reveal>
        </div>

        <ul className="mt-10 grid grid-cols-1 gap-10 sm:mt-14 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {TRANSFORM_ITEMS.map((item, index) => (
            <li key={item.title} className="flex flex-col items-center text-center">
              <Reveal variant="zoom" delay={index * 100}>
                <img src={item.icon} alt="" className="h-[60px] w-[60px]" />
              </Reveal>
              <Reveal variant="up" delay={index * 100 + 60}>
                <h3 className="mt-4 text-xl font-bold text-[#1B1B1B] lg:text-[24px]">{item.title}</h3>
              </Reveal>
              <Reveal variant="up" delay={index * 100 + 120}>
                <p className="mt-2 max-w-xs text-base font-medium leading-relaxed text-[#666666]">
                  {item.description}
                </p>
              </Reveal>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default TransformSection;
